import { render } from "./ContentblockImages.vue?vue&type=template&id=6e72a17c&scoped=true&ts=true"
import script from "./ContentblockImages.ts?vue&type=script&lang=ts"
export * from "./ContentblockImages.ts?vue&type=script&lang=ts"

import "./ContentblockImages.scss?vue&type=style&index=0&id=6e72a17c&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e72a17c"]])

export default __exports__